import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { subscribeOn } from 'rxjs/operators';
import {
  HomeMemberResult,
  shoppingListItem,
} from 'src/app/core/model/api-response/cooking-story-model';
import { CookingStoryGroceryService } from 'src/app/data/repository/cooking-story/cooking-story-grocery.service';
import { CookingStoryGroceryApiService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-api.service';
import { CookingStoryKitchenDataService } from 'src/app/data/repository/cooking-story/cooking-story-kitchen-data.service';
import { CookingStoryShoppinglistDateService } from 'src/app/data/repository/cooking-story/cooking-story-shoppinglist-date.service';
import { RecipeService } from 'src/app/data/repository/recipe-repository/recipe.service';
import { TutorialDataService } from 'src/app/data/repository/tutorial-repository/tutorial-data.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import Num2persian from 'src/app/utils/num2persian';
import { CookingStoryMembersMembersComponent } from '../cooking-story-members/cooking-story-members-members/cooking-story-members-members.component';
import { CookingStoryMembersShareComponent } from '../cooking-story-members/cooking-story-members-share/cooking-story-members-share.component';

@Component({
  selector: 'app-cooking-story-kitchen',
  templateUrl: './cooking-story-kitchen.component.html',
  styleUrls: ['./cooking-story-kitchen.component.scss'],
})
export class CookingStoryKitchenComponent implements OnInit, OnDestroy {
  activeTabTitle: string = 'لیست خرید';
  currenturl: string;
  type: string;
  activeTab: number = 0;
  shadowNav: boolean = false;
  isReady: boolean = false;
  showTutorial: boolean = false;
  isGerocerySelectdAll = false;
  isKitchenSelectdAll = false;
  subscriptions: Subscription[] = [];
  home: HomeMemberResult;
  unitlist;
  @ViewChild('scroolEl') scroolEl: ElementRef<HTMLDivElement>;

  constructor(
    private recipeService: RecipeService,
    private route: ActivatedRoute,
    private activeRoute: ActivatedRoute,
    private groceryApiService: CookingStoryGroceryApiService,
    private matBottomSheet: MatBottomSheet,
    private CookingStoryGroceryService: CookingStoryGroceryService,
    private TutorialDataService: TutorialDataService,
    private cookingStoryShoppinglistDateService: CookingStoryShoppinglistDateService,
    private snackBarService: SnackBarService,
    private cookingStoryKitchenDataService: CookingStoryKitchenDataService
  ) {
    this.currenturl = this.route.snapshot.paramMap.get('type');
    const sb = this.activeRoute.params.subscribe((qp) => {
      this.currenturl = qp['type'];
    });
    this.groceryApiService.getHomeMembers().then((homeDate) => {
      if (homeDate.isSuccess()) {
        this.home = homeDate.getData().getHomeMembers().home;
        this.isReady = true;
      }
    });
    this.CookingStoryGroceryService.itemAdded.subscribe((text) => {
      setTimeout(() => {
        this.CookingStoryGroceryService.openPopUp.next(
          ` به ${text} اضافه شد .`
        );
      }, 500);
    });
    const sb2 = this.CookingStoryGroceryService.closeTutorial.subscribe(
      (hide) => {
        if (hide) {
          this.showTutorial = false;
          this.TutorialDataService.getTutorial().then((res) => {
            if (this.type == 'kitchen') {
              res.kitchen = true;
              this.TutorialDataService.saveTutorial(res);
            } else {
              res.shoppingList = true;
              this.TutorialDataService.saveTutorial(res);
            }
          });
        }
      }
    );
    const changeTab = this.CookingStoryGroceryService.changeTab.subscribe(
      () => {
        this.changeTab(0);
      }
    );
    const deselcting =
      this.CookingStoryGroceryService.kitchenDeslecting.subscribe(() => {
        this.isKitchenSelectdAll = false;
      });
    const deselctingShoppingList =
      this.CookingStoryGroceryService.shoppingListDeslecting.subscribe(() => {
        this.isGerocerySelectdAll = false;
      });
    this.subscriptions.push(
      sb,
      sb2,
      deselcting,
      deselctingShoppingList,
      changeTab
    );
    this.checkTutorial();
  }
  toggleAllKitchenList() {
    const items = this.cookingStoryKitchenDataService.getItems();

    if (items.length > 0) {
      this.isKitchenSelectdAll = !this.isKitchenSelectdAll;
      this.CookingStoryGroceryService.toggleAllKitchenItems.next(
        this.isKitchenSelectdAll
      );
    } else {
      this.snackBarService.showSnackBar('سبد خرید خالی است .');
    }
  }
  checkTutorial() {
    this.TutorialDataService.getTutorial().then((res) => {
      if (this.currenturl == 'kitchen' && !res.kitchen) {
        this.type = 'kitchen';
        this.showTutorial = true;
      } else if (!res.shoppingList) {
        this.type = 'shoppingList';
        this.showTutorial = true;
      }
    });
  }
  toggleAllShoppingList() {
    const items = this.cookingStoryShoppinglistDateService.getItems();

    if (items.length > 0) {
      this.isGerocerySelectdAll = !this.isGerocerySelectdAll;
      this.CookingStoryGroceryService.toggleAllItems.next(
        this.isGerocerySelectdAll
      );
    } else {
      this.snackBarService.showSnackBar('سبد خرید خالی است .');
    }
  }
  async ngOnInit() {
    if (this.currenturl == 'kitchen') {
      this.changeTab(0);
    } else {
      this.changeTab(1);
    }
    this.unitlist =
      await this.cookingStoryShoppinglistDateService.getUnitList();
  }
  goBack() {
    this.recipeService.goTocookingbook();
  }
  copy(data) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = data;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snackBarService.showSnackBar('اشپزخانه کپی شد');
  }
  share() {
    // const bottomSheetRef = this.matBottomSheet.open(
    //   CookingStoryMembersShareComponent,
    //   {
    //     panelClass: 'custom-bottomsheet-container',
    //     data: {
    //       id: this.home._id,
    //     },
    //   }
    // );
    const items = this.cookingStoryShoppinglistDateService.getItems();

    if (items.length > 0) {
      let res = items.map((data) => {
        const name = data.name ? data.name : data.quickAdd;
        if (data.unit && data.amount) {
          const unit = this.getFoodUnit(data as any);
          const amount = data.amount ? data.amount : '';
          return `${name}  (${amount} ${unit}) `;
        } else if (data.unit) {
          const unit = this.getFoodUnit(data as any);

          return `${name}  ( ${unit}) `;
        }
        return `${name} `;
      });
      this.copy(res.join('\n'));
    } else {
      this.snackBarService.showSnackBar('سبد خرید خالی است .');
    }
  }
  getFoodUnit(food: shoppingListItem) {
    let foodunit = '';
    const unit = this.unitlist.filter((d) => {
      return food.unit == d._id;
    })[0];
    if (!food.unitDescription && food.unitDescription != '') {
      foodunit = unit.name;
    } else {
      foodunit = food.unitDescription;
    }

    return foodunit;
  }
  openMembers() {
    if (this.home) {
      const bottomSheetRef = this.matBottomSheet.open(
        CookingStoryMembersMembersComponent,
        {
          panelClass: 'custom-bottomsheet-container',
          data: this.home,
        }
      );
    }
  }
  scrolling(data) {
    let scroolTop = this.scroolEl.nativeElement.scrollTop;
    if (scroolTop >= 15) {
      this.shadowNav = true;
    } else {
      this.shadowNav = false;
    }
  }
  changeTab(id: number) {
    if (id == 0) {
      this.activeTab = 1;
      this.activeTabTitle = 'آشپزخانه';
      this.recipeService.goToKitchen('kitchen');
    } else if (id == 1) {
      this.activeTab = 0;
      this.activeTabTitle = 'لیست خرید';
      this.recipeService.goToKitchen('shoppinglist');
    }
    this.goToTop();
    this.checkTutorial();
  }
  goToTop() {
    const el1 = document.getElementById('cooking-story-kitchen');
    if (el1) el1.scrollTop = 0;
    const el2 = document.getElementById('cooking-story-shoppingList');
    if (el2) el2.scrollTop = 0;
    const el3 = this.scroolEl?.nativeElement;
    if (el3) {
      el3.scrollTop = 0;
      el3.scrollTo({ top: 0 });
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
}
